import { render, staticRenderFns } from "./PluginsTraining.vue?vue&type=template&id=2e76e2ae"
import script from "./PluginsTraining.vue?vue&type=script&lang=js"
export * from "./PluginsTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports